import dayjs from "dayjs";

export const NOW = dayjs();
